import * as React from 'react';
type Props = {
  className?: string;
};
export function FreshFish({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Fresh fish"
      className={className}
    >
      <path
        d="M14.4286 20.2377L18.1429 22.2001V15.2857L14.4286 17.4832M23.7985 16.5429C23.7985 16.5429 24.8131 19.4658 23.7985 22.2001M26.8937 16.5429C26.8937 16.5429 27.9084 19.4658 26.8937 22.2001M1.42859 19.7939C1.42859 19.7939 12.2081 3.77329 32.2064 18.0967L38.5714 14.0468V26.1947L32.2064 21.7563C32.2064 21.7563 15.533 36.7103 1.42859 19.7939ZM7.61907 18.1143C7.62789 18.4569 7.453 18.7773 7.16227 18.9513C6.87154 19.1253 6.51074 19.1254 6.21989 18.9516C5.92904 18.7778 5.75394 18.4575 5.76254 18.115C5.77537 17.6039 6.187 17.1963 6.6905 17.1961C7.194 17.196 7.6059 17.6033 7.61907 18.1143Z"
        stroke="currentColor"
      />
    </svg>
  );
}
